import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FundraiserOrganizationInfo } from "../../FundraiserOrganizationInfo/FundraiserOrganizationInfo";
import type { SanityImageObject } from "@sanity/image-url";
import styles from "../FundraiserWidget.module.scss";
interface OrganizationInfoPaneProps {
  organizationInfo: {
    name: string;
    logo: SanityImageObject;
    textTemplate: string;
    organizationSlug: string;
  };
  buttonText: string;
  onNext: () => void;
  className?: string;
  visible?: boolean;
}
export const OrganizationInfoPane = React.forwardRef<HTMLDivElement, OrganizationInfoPaneProps>((t0, ref) => {
  const $ = _c(16);
  const {
    organizationInfo,
    buttonText,
    onNext,
    className,
    visible
  } = t0;
  const t1 = visible ? "block" : "none";
  let t2;
  if ($[0] !== t1) {
    t2 = {
      display: t1
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== organizationInfo.logo || $[3] !== organizationInfo.name || $[4] !== organizationInfo.organizationSlug || $[5] !== organizationInfo.textTemplate) {
    t3 = <FundraiserOrganizationInfo name={organizationInfo.name} logo={organizationInfo.logo} textTemplate={organizationInfo.textTemplate} organizationSlug={organizationInfo.organizationSlug} />;
    $[2] = organizationInfo.logo;
    $[3] = organizationInfo.name;
    $[4] = organizationInfo.organizationSlug;
    $[5] = organizationInfo.textTemplate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== buttonText || $[8] !== onNext) {
    t4 = <button type="submit" className={styles["donation-widget__button"]} onClick={onNext} data-cy="fundraiser-start-button">{buttonText}</button>;
    $[7] = buttonText;
    $[8] = onNext;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== className || $[11] !== ref || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div ref={ref} className={className} style={t2} data-cy="fundraiser-pane-organization">{t3}{t4}</div>;
    $[10] = className;
    $[11] = ref;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
});
OrganizationInfoPane.displayName = "OrganizationInfoPane";